import "core-js/modules/es.array.push.js";
import { mapMutations, mapState } from "vuex";
import CountryCode from "@/components/countryCode/countryCode.vue";
import FootLanguage from "../components/Layout/footLanguage.vue";
import Agreenment from "@/components/Agreenment/agreenment.vue";
import LoginVerificationCode from "@/views/Login/login-verification-code.vue";
import Verify from "@/components/verifition/Verify.vue";
import _ from "lodash";
import { encrypt } from "@/libs/rsa";
import { changeI18nLanguage, isWeiXinLogin, onInputRange } from "@/utils/util.js";
import { continueRegistrationVerification } from "@/utils/registration-verification";
import { emailVerificationCode, mobileVerificationCode, regist, wxBindWithRegister, checkUUID, bindNew } from "@/service/user";
export default {
  components: {
    CountryCode,
    FootLanguage,
    Agreenment,
    LoginVerificationCode,
    Verify
  },
  data() {
    return {
      onInputRange,
      loading: false,
      isInviteLink: false,
      scanReady: false,
      submitForm: {},
      scanLoginInfo: {
        candidateUnits: []
      },
      step: 1,
      // 1- 首页 2- 手机/邮箱注册输入 3- 手机/邮箱验证码注册
      regist: {
        loginType: "MOBILE",
        formData: {
          mobile: "",
          email: "",
          verificationCode: "",
          mobileAreaCode: "+86"
        },
        agreed: false
      },
      rules: {
        email: [{
          required: true,
          message: $t("irio214", "邮箱必填"),
          trigger: "blur"
        }, {
          pattern: /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
          message: $t("venleq7", "邮箱格式不正确"),
          trigger: "blur"
        }]
      }
    };
  },
  computed: {
    ...mapState({
      language: state => state.app.language
    }),
    uuid() {
      return this.$route.query.uuid;
    },
    mode() {
      return this.uuid ? "WXBIND" : "REGISTER";
    },
    columns() {
      const h = this.$createElement;
      return [{
        key: "orgCode",
        rules: [{
          required: true,
          message: $t("augvi44", "单位必选"),
          trigger: "blur,change"
        }],
        renderForm: () => {
          var _this$scanLoginInfo;
          return _.isEmpty((_this$scanLoginInfo = this.scanLoginInfo) === null || _this$scanLoginInfo === void 0 ? void 0 : _this$scanLoginInfo.candidateUnits) ? h("div", [h("div", {
            "style": {
              marginBottom: "5px",
              fontWeight: "bold",
              color: "#000"
            }
          }, [$t("ely02", "单位")]), h("Input", {
            "attrs": {
              "placeholder": $t("ely02", "单位")
            },
            "model": {
              value: this.submitForm.orgCode,
              callback: $$v => {
                this.$set(this.submitForm, "orgCode", $$v);
              }
            }
          })]) : h("div", [h("div", {
            "style": {
              marginBottom: "5px",
              fontWeight: "bold",
              color: "#000"
            }
          }, [$t("ely02", "单位")]), h("ProSelect", {
            "attrs": {
              "list": this.scanLoginInfo.candidateUnits,
              "map": {
                valuePath: "code",
                titlePath: "name"
              }
            },
            "model": {
              value: this.submitForm.orgCode,
              callback: $$v => {
                this.$set(this.submitForm, "orgCode", $$v);
              }
            }
          })]);
        }
      }, {
        key: "userCode",
        rules: [{
          required: true,
          message: $t("a2vi1e7", "用户名不能为空"),
          trigger: "blur,change"
        }],
        renderForm: () => {
          return h("div", [h("div", {
            "style": {
              marginBottom: "5px",
              fontWeight: "bold",
              color: "#000"
            }
          }, [$t("hmxge3", "用户名")]), h("Input", {
            "attrs": {
              "placeholder": $t("hmxge3", "用户名")
            },
            "model": {
              value: this.submitForm.userCode,
              callback: $$v => {
                this.$set(this.submitForm, "userCode", $$v);
              }
            }
          })]);
        }
      }, {
        key: "pw",
        rules: [{
          required: true,
          message: $t("pcjrt76", "密码不能为空"),
          trigger: "blur,change"
        }],
        renderForm: () => {
          return h("div", [h("div", {
            "style": {
              marginBottom: "5px",
              fontWeight: "bold",
              color: "#000"
            }
          }, [$t("g9ob2", "密码")]), h("Input", {
            "attrs": {
              "placeholder": $t("g9ob2", "密码"),
              "type": "password"
            },
            "model": {
              value: this.submitForm.pw,
              callback: $$v => {
                this.$set(this.submitForm, "pw", $$v);
              }
            }
          })]);
        }
      }];
    }
  },
  async created() {
    const {
      uuid
    } = this.$route.query;
    const {
      inviteCode,
      accountType,
      mobile,
      email
    } = this.$route.query;
    if (inviteCode) {
      this.regist.loginType = accountType;
      if (mobile.indexOf("-") > -1) {
        //手机号存在区号 拆分区号和手机号
        const arr = mobile.split("-");
        this.regist.formData.mobile = arr[1];
        this.regist.formData.mobileAreaCode = arr[0];
      } else {
        this.regist.formData.mobile = mobile || "";
      }
      this.regist.formData.email = email || "";
      this.isInviteLink = true;
    }
    if (uuid) {
      var _res$data, _res$data2;
      const res = await checkUUID(uuid);
      this.scanLoginInfo = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.retVal;
      const language = (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.retVal) === null || _res$data2 === void 0 ? void 0 : _res$data2.language) || "zh-CN";
      const languageCode = await changeI18nLanguage(language);
      if (languageCode) {
        this.setLanguage(languageCode);
      }
      // 扫码绑定页等服务端语言同步后再挂载表单，避免切语言时触发空手机号校验。
      this.setStep(2, "MOBILE");
      this.scanReady = true;
      this.clearRegisterValidate();
    } else {
      this.scanReady = true;
    }
  },
  mounted() {
    // 页面加载时清除表单校验状态
    this.$nextTick(() => {
      this.clearRegisterValidate();
    });
  },
  methods: {
    ...mapMutations(["setLogin", "setLanguage"]),
    onBack() {
      this.setStep(this.step - 1);
      if (this.step === 1) {
        this.regist.loginType = "";
        this.regist.formData.mobile = "";
        this.regist.formData.mobileAreaCode = "+86";
        this.regist.formData.email = "";
        this.regist.formData.verificationCode = "";
      }
      this.$refs.countryCode.clean();
      this.$refs.form.resetFields();
    },
    goToOther(name) {
      this.$router.push({
        name
      });
    },
    setStep(step, loginType) {
      this.step = step;
      if (loginType) {
        this.regist.loginType = loginType;
      }
    },
    clearRegisterValidate() {
      const clearRefs = () => {
        var _this$$refs, _this$$refs2, _this$$refs3;
        [(_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.form, (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 || (_this$$refs2 = _this$$refs2.countryCode) === null || _this$$refs2 === void 0 || (_this$$refs2 = _this$$refs2.$refs) === null || _this$$refs2 === void 0 ? void 0 : _this$$refs2.form, (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : _this$$refs3.bindNew].forEach(ref => {
          if (ref && typeof ref.clearValidate === "function") {
            ref.clearValidate();
          }
        });
      };
      this.$nextTick(() => {
        clearRefs();
        this.$nextTick(() => {
          clearRefs();
        });
      });
    },
    handleResend() {
      this.$refs.verify.show();
    },
    onCompleteVerify(completeCode) {
      this.regist.formData.verificationCode = completeCode;
    },
    handleCloseVerify() {
      this.$refs.verificationCode.resetCountdown();
    },
    handleSuccessVerify(value) {
      if (this.regist.loginType === "EMAIL") {
        this.onVerifyEmail(value);
      } else if (this.regist.loginType === "MOBILE") {
        this.onVerifyMobile(value);
      }
    },
    async bindNew() {
      this.$refs["bindNew"].validate(async valid => {
        if (valid) {
          const {
            userCode,
            orgCode
          } = this.submitForm;
          const password = encrypt(this.submitForm.pw);
          const res = await bindNew({
            session: this.uuid,
            userCode,
            password,
            orgCode
          });
          if (res.data && res.data.result === 0) {
            // 判断是否在微信环境
            if (isWeiXinLogin()) {
              this.$router.push({
                name: "Login"
              });
            } else {
              this.$router.push({
                name: "Success",
                query: {
                  uuid: this.uuid,
                  language: this.language
                }
              });
            }
          }
        }
      });
    },
    /**
     * 验证码验证成功，发送验证码 - 邮箱
     */
    async onVerifyEmail(value) {
      const res = await emailVerificationCode(this.regist.formData.email, value.captchaVerification, this.mode);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("px9tpm6", "验证码已发送"));
        // 验证码发送成功，开始倒计时
        this.$refs.verificationCode.startCountdown();
      } else if (res.data.result === 10012) {
        // 验证码发送失败，重置倒计时
        this.$refs.verificationCode.resetCountdown();
      } else {
        this.setStep(2);
      }
    },
    /**
     * 验证码验证成功，发送验证码 - 手机
     */
    async onVerifyMobile(value) {
      const res = await mobileVerificationCode(this.regist.formData.mobile, value.captchaVerification, this.mode, this.regist.formData.mobileAreaCode);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("hu974i5", "短信已发送"));
        // 验证码发送成功，开始倒计时
        this.$refs.verificationCode.startCountdown();
      } else if (res.data.result === 10007) {
        // 验证码发送失败，重置倒计时
        this.$refs.verificationCode.resetCountdown();
      } else {
        this.setStep(2);
      }
    },
    /**
     * 校验邮箱/手机号，首次发送前先完成图形验证码验证。
     */
    async handleContinueVerfy() {
      continueRegistrationVerification({
        loginType: this.regist.loginType,
        validateMobile: callback => this.$refs.countryCode.validate(callback),
        validateEmail: callback => this.$refs.form.validate(callback),
        showVerification: () => this.$refs.verify.show(),
        goToVerificationStep: () => this.setStep(3)
      });
    },
    /**
     * 提交注册
     */
    async handleContinueSubmit() {
      this.loading = true;
      if (!this.regist.agreed) {
        this.$Message.warning($t("xsngcsh", "请阅读后勾选同意用户协议、隐私政策"));
        this.loading = false;
        return;
      }
      if (!this.regist.formData.verificationCode) {
        this.loading = false;
        this.$Message.warning($t("7b32n16", "请输入验证码"));
        return;
      }
      const {
        mobile,
        email,
        verificationCode,
        mobileAreaCode
      } = this.regist.formData;
      let res;
      if (this.uuid) {
        const obj = {
          uuid: this.uuid,
          type: "wechat",
          mobile,
          verificationCode,
          mobileAreaCode
        };
        res = await wxBindWithRegister(obj);
      } else {
        res = await regist({
          mobile,
          email,
          verificationCode,
          mobileAreaCode,
          mode: this.regist.loginType
        });
      }
      if (res.data && res.data.result === 0) {
        this.loading = false;
        this.setLogin(true);
        if (this.isInviteLink) {
          //进入加入页面
          this.$router.push({
            path: "/join",
            query: {
              ...this.$route.query,
              userId: res.data.retVal
            }
          });
        } else {
          // 判断是否在微信环境
          if (isWeiXinLogin()) {
            this.$router.push({
              name: "Login"
            });
          } else {
            this.$router.push(_.merge({
              name: this.uuid ? "Success" : "MGT/communicationUser"
            }, this.uuid ? {
              query: {
                uuid: this.uuid,
                language: this.language
              }
            } : {}));
          }
        }
      } else {
        this.loading = false;
      }
    }
  }
};